<template>
  <div class="full-screen">
    <document-header
      :modeEdit="modeEdit"
      :edit="edit"
      :document="document"
      :updateHtml="updateContractualDocumentHtml"
      :reload="getContractualDocumentLocal"
    />
    <div class="main-doc">
      <div class="body" :class="{'pd-2': !edit}">
        <div class="doc-frame loader-center" v-if="isLoading">
          <div class="loader is-loading is-blue"></div>
        </div>
        <div v-show="!isLoading && !edit && (document && (document.type === 'html'))" class="doc-frame" v-html="document ? document.template : ''"></div>
        <div v-show="!isLoading && edit && (document && (document.type === 'html'))">
          <div v-show="!showHtmlModal" class="has-text-confirmation editor-container">
            <div class="editor" ref="quillEditor"></div>
          </div>
          <div v-show="showHtmlModal" class="html-modal">
            <div class="buttons">
              <button class="button is-small" @click="saveHtmlContent">Ocultar editor html</button>
            </div>
            <textarea v-model="htmlContent" class="html-textarea"></textarea>
          </div>
        </div>
        <iframe
          v-if="!isLoading && !edit && document && document.type === 'docx'"
          class="doc-frame"
          :src="`https://docs.google.com/gview?url=${encodeURIComponent(documentWordUrl)}&embedded=true`">
        </iframe>
        <div v-if="!isLoading && document && !document.type" class="empty-content">
          <div class="content-wrapper">
            <div class="icon-section">
              <img src="@/assets/documentplus.png" class="document-icon" />
            </div>
            <div class="description">
              <h3>Crea tu plantilla</h3>
              <p>Sube tu plantilla en html y editala con nuestro editor o cargar tu word ya con las variables para generar tu documento.</p>
              <button @click="openShowModalAdd" class="button is-template-upload">Subir plantilla</button>
            </div>
          </div>
        </div>
      </div>
      <document-sidebar
        :edit="edit"
        :document="document"
      />
      <modal-add-template
        v-if="showModalAdd"
        :close="closeModalAdd"
        :active="showModalAdd"
        :reload="getContractualDocumentLocal"
        :document="document"
        :openGuideModal="openGuideModal"
      />
      <modal-download-guide
        v-if="showGuideModal"
        :active="showGuideModal"
        :close="closeGuideModal"
        :preSelectedType="selectedGuideType"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import HtmlEditButton from 'quill-html-edit-button'

import mixins from '@/mixins/formats'
import DocumentSidebar from '@/components/ContractualDocuments/DocumentSidebar.vue'
import DocumentHeader from '@/components/ContractualDocuments/DocumentHeader.vue'
import ModalAddTemplate from '@/components/ContractualDocuments/ModalAddTemplate.vue'
import ModalDownloadGuide from '@/components/ContractualDocuments/ModalDownloadGuide.vue'

export default {
  name: 'DocumentosContractuales',
  mixins: [mixins],
  components: {
    DocumentSidebar,
    DocumentHeader,
    ModalAddTemplate,
    ModalDownloadGuide
  },
  data () {
    return {
      isLoading: true,
      edit: false,
      quill: null,
      htmlContent: null,
      showHtmlModal: false,
      item: null,
      showModalAdd: false,
      showGuideModal: false,
      selectedGuideType: null, // Agregado para preseleccionar el tipo
      document: null,
      documentWordUrl: null
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: state => state.financialCompany
    })
  },
  async mounted () {
    this.getContractualDocumentLocal()
  },
  methods: {
    ...mapActions(['getContractualDocument', 'updateContractualDocumentTemplateHtml', 'getDocumentWord']),
    async getContractualDocumentLocal () {
      const document = await this.getContractualDocument(Number(this.$route.params.documentId))
      if (document.fileNameS3) {
        const documentWord = await this.getDocumentWord(Number(this.$route.params.documentId))
        this.documentWordUrl = documentWord?.url || null
      }
      this.document = document
      if (this.document) {
        // console.log(this.$refs)
        // const doc = this.$refs.iframe.contentWindow.document
        // doc.open()
        // doc.write(this.document.template)
        // doc.close()
      }
      this.isLoading = false
    },
    modeEdit () {
      if (this.document.type === 'html') {
        this.edit = !this.edit
        if (this.edit) {
          this.initializeQuill()
        }
      }
      if (this.document.type === 'docx') {
        // Abrir modal para cargar docx
        this.openShowModalAdd()
      }
    },
    initializeQuill () {
      setTimeout(() => {
        if (Quill && HtmlEditButton) {
          Quill.register('modules/htmlEditButton', HtmlEditButton)
        }
        if (!this.$refs?.quillEditor) {
          return
        }
        if (this.quill) {
          return // Ya existe, no vuelvas a crearlo
        }
        this.quill = new Quill(this.$refs.quillEditor, {
          theme: 'snow',
          placeholder: 'Escribe tu aquí...',
          modules: {
            toolbar: {
              container: [
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                ['link', 'image'],
                [{ header: 1 }, { header: 2 }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ script: 'sub' }, { script: 'super' }],
                [{ indent: '-1' }, { indent: '+1' }],
                [{ size: ['small', false, 'large', 'huge'] }],
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ color: [] }, { background: [] }],
                [{ font: [] }],
                [{ align: [] }],
                ['clean'],
                ['htmlButton'] // 👈 Aquí pones el botón personalizado
              ],
              handlers: {
                htmlButton: () => {
                  this.openHtmlModal()
                }
              }
            }
          }
        })
        if (this.document.template) {
          this.quill.clipboard.dangerouslyPasteHTML(this.document.template)
        }
        this.quill.getModule('toolbar')
        const button = document.querySelector('.ql-htmlButton')
        if (button) {
          button.innerHTML = '<i class="fas fa-code"></i>' // Puedes poner tu icono o texto
        }
      }, 100)
    },
    saveHtmlContent () {
      if (this.quill && this.htmlContent !== null) {
        this.quill.clipboard.dangerouslyPasteHTML(this.htmlContent)
      }
      this.showHtmlModal = false
    },
    openHtmlModal () {
      this.htmlContent = this.quill.root.innerHTML
      this.showHtmlModal = true
    },
    openShowModalAdd () {
      this.showModalAdd = true
    },
    closeModalAdd () {
      this.showModalAdd = false
    },
    // Agregado: método para abrir el modal de guías
    openGuideModal (type = null) {
      this.selectedGuideType = type
      this.showGuideModal = true
      this.showModalAdd = false // Cerrar el modal de agregar plantilla
    },
    closeGuideModal () {
      this.showGuideModal = false
      this.selectedGuideType = null
      this.showModalAdd = true // Volver a abrir el modal de agregar plantilla
    },
    async updateContractualDocumentHtml () {
      const response = await this.updateContractualDocumentTemplateHtml({
        contractualDocumentId: Number(this.$route.params.documentId),
        template: this.showHtmlModal ? this.htmlContent : this.quill.root.innerHTML
      })
      return response
    }
  }
}
</script>

<style lang="scss" scoped>
.full-screen {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  .main-doc {
    width: 100%;
    flex-direction: row;
    display: flex;
    .body {
      width: calc(100vw - 250px);
      height: calc(100vh - 134px);
    }
  }
}
.pd-2 {
  padding: 2rem;
}
.doc-frame {
  width: 100% !important;
  height: calc(100vh - 200px) !important;
  background: #fff !important;
  box-shadow: 0 5px 5px rgba(0, 0, 0, .15) !important;
  overflow-y: scroll;
  overflow-x: scroll;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}
.editor-container {
  .editor {
    background: #fff;
    height: calc(100vh - 210px);
  }
}
.html-modal {
  background: white;
  border: 1px solid #ccc;
  .html-textarea {
    width: 100%;
    height: calc(100vh - 200px);
    border: none;
    padding: 1rem;
  }
  .buttons {
    padding-top: 1rem;
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: left;
    padding-left: 1rem;
  }
}
.empty-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 300px);

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: 500px;
  }

  .icon-section {
    margin-bottom: 1rem;

    .document-icon {
      width: 80px;
      height: 80px;
      opacity: 0.7;
    }
  }

  .description {
    color: #484c53;

    h3 {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 1rem;
      color: #333;
    }

    p {
      font-size: 16px;
      line-height: 1.5;
      margin-bottom: 2rem;
      color: #666;
    }

    .button.is-template-upload {
      background: #5fd39c !important;
      color: white;
      border: none;
      padding: 11px 24px;
      font-size: 14px;
      font-weight: 500;
      border-radius: 6px;
      cursor: pointer;
      transition: background-color 0.3s ease;
      height: 35px;

      &:hover {
        background: #5fd39c !important;
      }
    }
  }
}
.loader {
  border: 12px solid #2cb0f8;
  border-right-color: transparent;
  border-top-color: transparent;
  height: 6em;
  width: 6em;
  animation: spinAround 700ms infinite linear;
}
.loader-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
